export default __webpack_public_path__ + "static/landing1-27e8cf2f165fe7298637d151a5fd3cbf.jpg";